// Usage instructions:

// 0. Define this.elm as the wrapper container (base for the DOM events delegation)
// 1. Define this.elmMain as the container where layout will be loaded in
// 2. Define this.navigationOptions as an array of hashes with properties: id, label, className, icon
// 3. Define preselected element ID with this.navigationSelectedItem
// 4. Call this.initTabsLayout() to render, do not set a capability if you don't want linked accounts to be
//    part of the leftnav.
// 5. Bind to 'sideTabsLayout:accountConnected' event on the bus for instance
//    to select the right tab after a new account has been connected.

// CSS files to include: lib/side-tabs-box.scss, lib/providers_matrix.scss

define('views/lib/Podio.Views.SideTabsLayout',['require','lib/backbone/Backbone.PodioView','jst!shared/_side_tabs_box','jst!shared/_side_tabs_navigation','jst!filefinder/_badge_count'],function(require) {

  var ViewPodioBase = require('lib/backbone/Backbone.PodioView');

  var jstSideTabsBox = require('jst!shared/_side_tabs_box');
  var jstSideTabsNavigation = require('jst!shared/_side_tabs_navigation');
  var jstBadgeCount = require('jst!filefinder/_badge_count');

  var view = {
    podioEvents: {
      'click .navigation li'  : 'onNavItemClicked',
      'click .footer .cancel' : 'onFooterCancelButtonClicked',
      'click .footer .done'   : 'onFooterDoneButtonClicked'
    },

    initTabsLayout: function() {
      this.render();
    },

    render: function() {

      this.elmMain.html(this.getTemplate(jstSideTabsBox));
      this.elmContent = this.elmMain.find('.content');
      this.elmNavigation = this.elmMain.find('.navigation');
      this.renderNavigation(this.navigationOptions, this.navigationSelectedItem);

      // Bind events
      this.podioDelegateEvents();
    },

    renderNavigation: function(options, selectedItem) {
      this.elmNavigation.html(this.getTemplate(jstSideTabsNavigation, {
        navigationOptions: options,
        selectedItem : selectedItem
      }));

      this.trigger('sideTabsLayout:navigationRendered');
    },

    hide: function() {
      this.remove();
      this.disableShortcuts();
    },

    destroy: function() {
      this.podioUndelegateEvents();
      this.remove();
    },

    getSelectedTab: function() {
      return this.selectedTabId;
    },

    getContentEl: function() {
      return this.elmContent;
    },

    resetCounters: function() {
      var elmCounters = this.elmNavigation.find('li .img-ext');
      elmCounters.empty();
    },

    setCounter: function(id, count) {
      var elmTarget = this.elmNavigation.find("li[data-id='" + id + "'] .img-ext");

      if (count > 0) {
        elmTarget.html(this.getTemplate(jstBadgeCount, {
          count: count,
          className: 't-badge-count-blue'
        }));
      } else {
        elmTarget.empty();
      }
    },

    selectNavItem: function(id) {
      var elmItem = this.elmNavigation.find('*[data-id={0}]'.format(id));
      elmItem.addClass('selected');
      elmItem.siblings().removeClass('selected');
    },

    // Event handlers
    onNavItemClicked: function(elmTarget, e) {
      this.selectedTabId = elmTarget.data('id');

      this.selectNavItem(this.selectedTabId);
      this.trigger('sideTabsLayout:navItemSelected', this.selectedTabId);
    },

    onFooterDoneButtonClicked: function(elmTarget, e) {
      this.trigger('sideTabsLayout:doneTriggered');
    },

    onFooterCancelButtonClicked: function(elmTarget, e) {
      this.trigger('sideTabsLayout:cancelTriggered');
    }
  };

  return ViewPodioBase.extend(view, { mixin: view });

});

